import { useRef } from "react";
import { useContext } from "react";
import { useEffect } from "react";
// import Context from "../../Context/Context";
import styles from "./PopupWrapper.module.css";

export const PopupWrapper = (props) => {
  const { visible, children } = props;
  // const { modalRef } = useContext(Context);
  // useEffect(() => {
  //   const checkIfClickedOutside = (e) => {
  //     // If the modal is open and the clicked target is not within the modal,
  //     //then close the modal
  //     if (visible && modalRef.current && !modalRef.current.contains(e.target)) {
  //       setpopUp(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", checkIfClickedOutside);
  //   // Cleanup the event listener
  //   return () => {
  //     document.removeEventListener("mousedown", checkIfClickedOutside);
  //   };
  // }, [visible]);

  return (
    <>{visible && <div className={`no-scrollbar ${styles.popupWrapper}`}>{children}</div>}</>
  );
};
